// Story 070a — central registry of locales the app supports. Adding
// a new locale is a deliberate step: extend this array, add the
// catalog files, and run the migration that bumps the CHECK
// constraint on user_locale.locale.
//
// `xx-XX` is a smoke/test locale only. The catalog is auto-prefixed
// with `[XX]` so e2e tests can switch a user to it and assert every
// visible string starts with `[XX]` — anything that didn't go
// through t() shows up unbracketed. Not exposed in the user-facing
// locale picker.
export const SUPPORTED_LOCALES = ['en', 'pl', 'de'];
const TEST_LOCALES = ['xx-XX'];
export const DEFAULT_LOCALE = 'en';
export const ALL_NAMESPACES = [
    'common',
    'auth',
    'tournament',
    'player',
    'director',
    'notifications',
    'email',
    'errors',
    'validation',
];
export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
export function isAnyLocale(value) {
    return (isSupportedLocale(value) ||
        TEST_LOCALES.includes(value));
}
//# sourceMappingURL=supported.js.map